import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import isEmpty from 'lodash/isEmpty'
import intersection from 'lodash/intersection'
import ListItem from '@pc/components/Works/Panel/shared/list/ListItem'
import ListItemParagraph from '@pc/components/Works/Panel/shared/list/ListItemParagraph'
import ListItemName from '@pc/components/Works/Panel/shared/list/ListItemName'
import ListOpenIcon from '@pc/components/Works/Panel/shared/list/ListOpenIcon'
import ListCloseIcon from '@pc/components/Works/Panel/shared/list/ListCloseIcon'
import StationCheckboxes from './StationCheckboxes'
import type { Line, Station } from '@pc/components/Works/Panel/type'

interface PropsType {
  line: Line
  stations: Station[]
  selectedStationIds: string[]
  changeStationIds: (stationIds: string[]) => void
}

const LineListItem = styled(ListItem)`
  cursor: pointer;
  margin-left: 20px;
  transition: all 0.2s;
`

const LineListItemParagraph = styled(ListItemParagraph)`
  display: flex;
  position: relative;

  svg {
    position: absolute;
    right: 15px;
  }
`

const LineListItemName = styled(ListItemName)`
  min-width: 250px;
`

const LineItem = (props: PropsType) => {
  const { line, stations, selectedStationIds, changeStationIds } = props
  const [childrenIsOpen, setChildrenIsOpen] = useState(false)

  const isSelectedBeforehand = () => {
    const { stations, selectedStationIds } = props
    return !isEmpty(
      intersection(
        stations.map((station) => station.attributes.compat_id.toString()),
        selectedStationIds
      )
    )
  }

  const toggleChildren = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault()
    setChildrenIsOpen(!childrenIsOpen)
  }

  useEffect(() => {
    if (isSelectedBeforehand()) {
      setChildrenIsOpen(true)
    }
  }, [])

  return (
    <LineListItem>
      <LineListItemParagraph onClick={toggleChildren}>
        <LineListItemName>{line.attributes.name}</LineListItemName>
        {childrenIsOpen ? <ListCloseIcon /> : <ListOpenIcon />}
      </LineListItemParagraph>
      {childrenIsOpen && (
        <StationCheckboxes line={line} stations={stations} selectedStationIds={selectedStationIds} changeStationIds={changeStationIds} />
      )}
    </LineListItem>
  )
}

export default LineItem
